import React from "react";

import NotificationPanel from "./components/NotificationPanel";
import NotificationTrigger from "./components/NotificationTrigger";
import { useNotificationState } from "./hooks/useNotificationState";
import "./notification.scss";

function Notification() {
  const notificationState = useNotificationState();

  return (
    <>
      <NotificationTrigger
        unreadCount={notificationState.unreadCount}
        onOpen={notificationState.handleOpen}
      />
      <NotificationPanel
        anchorEl={notificationState.anchorEl}
        isError={notificationState.isError}
        isLoading={notificationState.isLoading}
        items={notificationState.items}
        onClose={notificationState.handleClose}
        onNotificationClick={notificationState.handleNotificationClick}
        open={notificationState.open}
        refetch={notificationState.refetch}
        unreadCount={notificationState.unreadCount}
        isNotificationUnread={notificationState.isNotificationUnread}
      />
    </>
  );
}

export default React.memo(Notification);
